<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.7847 15.3538L11.285 14.7296L10.7847 15.3538ZM12 9.90096L11.4191 10.451C11.5702 10.6106 11.7802 10.701 12 10.701C12.2198 10.701 12.4298 10.6106 12.5809 10.451L12 9.90096ZM13.2153 15.3538L13.7156 15.9781L13.2153 15.3538ZM11.285 14.7296C10.6494 14.2202 10.0413 13.7867 9.55348 13.2282C9.09294 12.7011 8.8 12.1229 8.8 11.3796H7.2C7.2 12.6137 7.71094 13.5511 8.34853 14.2809C8.95878 14.9794 9.7431 15.5443 10.2844 15.9781L11.285 14.7296ZM8.8 11.3796C8.8 10.683 9.18649 10.1324 9.66214 9.91139C10.0837 9.71553 10.7225 9.71524 11.4191 10.451L12.5809 9.35093C11.4776 8.18566 10.1164 7.93601 8.98791 8.46039C7.91355 8.95961 7.2 10.0989 7.2 11.3796H8.8ZM10.2844 15.9781C10.4846 16.1386 10.7315 16.3362 10.9895 16.4895C11.247 16.6424 11.5936 16.8 12 16.8V15.2C12.0064 15.2 11.953 15.2009 11.8067 15.1139C11.6609 15.0273 11.5 14.9019 11.285 14.7296L10.2844 15.9781ZM13.7156 15.9781C14.2569 15.5443 15.0412 14.9794 15.6515 14.2809C16.2891 13.5511 16.8 12.6137 16.8 11.3796H15.2C15.2 12.1229 14.9071 12.7011 14.4465 13.2282C13.9587 13.7867 13.3506 14.2202 12.715 14.7296L13.7156 15.9781ZM16.8 11.3796C16.8 10.0989 16.0865 8.95961 15.0121 8.46039C13.8836 7.93601 12.5224 8.18566 11.4191 9.35093L12.5809 10.451C13.2775 9.71524 13.9163 9.71553 14.3379 9.91139C14.8135 10.1324 15.2 10.683 15.2 11.3796H16.8ZM12.715 14.7296C12.5 14.9019 12.3391 15.0273 12.1933 15.1139C12.047 15.2009 11.9936 15.2 12 15.2V16.8C12.4064 16.8 12.753 16.6424 13.0105 16.4895C13.2685 16.3362 13.5154 16.1386 13.7156 15.9781L12.715 14.7296Z"
            fill="currentColor"
        />
        <path
            d="M12 2V4"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M12 20V22"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M2 12L4 12"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M20 12L22 12"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M6 18L6.34305 17.657"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M17.6562 6.34326L17.9995 6"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M18 18L17.657 17.657"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
        <path
            d="M6.34375 6.34326L6.00049 6"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "HeartShineIcon",
    props: {
        strokeWidth: {
            type: String,
            default: "1.6",
        },
    },
});
</script>
